<template>
  <main class="query container-fluid mf_container pt_17 pb_50">
    <div class="btn__group d-flex justify-content-end pb_15">
      <button
        class="btn btn-default mr_10"
        :disabled="myComposeList.length == 0"
        @click.stop="deleteAllCompose()"
      >
        全部刪除
      </button>
      <button class="btn btn-primary" @click="createCompose()">新增收藏</button>
    </div>
    <h3>我的收藏組合列表</h3>
    <div class="text-red mt_7 fz_13">
      收藏組合匯入新增建議書時，將自動檢核商品是否停售，並剔除停售商品。
    </div>
    <!-- 列表清單 -->
    <div class="row mt_10" v-if="myComposeList.length != 0">
      <div
        class="composeCard mr-4 mt_20"
        v-for="(item, index) in myComposeList"
        :key="`group-item-${item.setgroup_idx}`"
      >
        <div class="composeCard__head d-flex">
          {{ item.createROCdate }} {{ item.createtime }}
          <div class="btn btn-default" @click="editCompose(item)">
            <i class="icon-edit i-24"></i>
          </div>
          <div class="btn btn-default" @click="deleteCompose(item, index)">
            <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
          </div>
        </div>
        <div class="composeCard__name d-flex mt_11 font-weight-bold">
          {{ truncate(item.setgroup_name, 30) }}
        </div>
        <div class="composeCard__info">
          <div
            class="btn btn-primary composeInfoButton"
            :tabindex="index"
            @click="showInfoData(index)"
            @focusout="
              item.showInfo = false;
              $forceUpdate();
            "
          >
            商品資訊
            <div
              class="
                composeInfoWrap
              "
            >
              <div
                class="composeInfoToast"
                v-show="item.showInfo"
                :tabindex="index"
              >
                <div
                  class="composeInfoToast__mc"
                  v-for="(mc, index) in item.group_mc_list"
                  :key="mc.mc_idx"
                >
                  <div class="composeInfoToast__mc__index mt_5">
                    建議{{ index + 1 }}:
                  </div>
                  <div class="mf-textWrap">
                    {{ mc.prod_name }}{{ `(${mc.prod_id})` }}
                  </div>
                  <div v-if="mc.group_sc_list.length > 0">
                    搭配附約:{{ mc.group_sc_list.length }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 無商品 -->
    <div class="noCompose" v-else>
      {{ ready ? "尚無收藏，請點擊右上方「新增收藏」開始新增" : "查詢中..." }}
    </div>
  </main>
</template>

<script>
import Avatar from "@/desktop/components/Avatar";
import mf_Mixin from "@/desktop/views/mf/mixin";
import _ from "lodash";
export default {
  components: { Avatar },
  mixins: [mf_Mixin],
  data() {
    return {
      myComposeList: [],
      ready: false
    };
  },
  created() {
    //呼叫API取得列表

    this.$store.commit("reset_Customer");
    this.init();
  },
  methods: {
    init() {
      this.$mfAPI
        .MFB0_2000__queryMyGroupList({
          agent_id: this.$store.state.userInfo.id
        })
        .then(res => {
          this.myComposeList = res.group_list;
          this.ready = true;
        });
    },
    showInfoData(index) {
      if (this.myComposeList[index].group_mc_list) {
        this.myComposeList[index].showInfo = true;
        this.$forceUpdate();
      } else {
        // this.$mfAPI
        //   .MFA0_1000__queryProposalDetailList({
        //     agent_id: this.$store.state.userInfo.id,
        //     insured_id: "",
        //     prod_idx: this.noIDProposalList[index].prod_idx,
        //   })
        //   .then((res) => {
        //     this.noIDProposalList[index] = {
        //       ...res.proposal[0],
        //       ...this.noIDProposalList[index],
        //     };
        //     this.noIDProposalList[index].showInfo = true;
        //     this.$forceUpdate();
        //   });
      }
    },
    deleteCompose(target, index) {
      this.$mfNotice(
        `您確定要刪除「${this.truncate(target.setgroup_name, 30)}」嗎?`,
        () => {
          this.myComposeList.splice(index, 1);
          this.$toast.info({ title: "刪除成功" });
          this.$mfAPI
            .MFB0_2000__deleteMyGroup({
              isDeleteAll: "0",
              setgroup_idx: target.setgroup_idx
            })
            .then(() => {
              this.init();
            });
        },
        true
      );
    },
    deleteAllCompose() {
      this.$mfNotice(
        `您確定要刪除全部的收藏組合嗎?`,
        () => {
          this.myComposeList = [];
          this.$mfAPI
            .MFB0_2000__deleteMyGroup({ isDeleteAll: "1" })
            .then(() => {
              this.init();
            });
        },
        true
      );
    },
    editCompose(target) {
      this.$store.commit("update_MfEditingCompose", {
        ...target
      });
      this.$router.push("/mf/composeEdit");
    },
    createCompose() {
      this.$store.commit("reset_MfEditingCompose");
      this.$router.push("/mf/composeEdit");
    }
  }
};
</script>

<style lang="scss">
.composeCard {
  flex-shrink: 0;
  width: 211px;
  height: 179px;
  border-radius: 8px;
  padding: 5px 10px 10px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #989ca2;
    .btn {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      width: 30px;
      height: 30px;
    }
  }
  &__name {
    flex-grow: 2;
  }
  &__info .btn {
    margin: 0 auto;
    width: 100%;
    min-height: 40px;
  }
}
.composeInfoButton {
  position: relative;
  .composeInfoWrap {
    position: absolute;
    left: 0;
    bottom: 30px;
    z-index: 99;
    .composeInfoToast {
      width: 240px;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 3px 3px 3px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #fff;
      background-color: #fff;
      color: #323a45;
      text-align: left;
      line-height: 1.38;
      &__mc__index {
        font-weight: 700;
        font-size: 18px;
      }
    }
  }
}
.noCompose {
  margin-top: 20vh;
  font-size: 24px;
  line-height: 0.92;
  letter-spacing: normal;
  text-align: center;
  color: #323a45;
  white-space: nowrap;
}
</style>
